<template>
  <b-container>
    <form-wrapper :validator="$v.model" v-if="isTransactive">
      <b-row class="my-3" v-if="showError">
        <b-col sm="12">
          <b-alert variant="danger" show>{{ $t('offerNotAvailable') }}</b-alert>
        </b-col>
      </b-row>      
      <b-row v-show="!isTimeSlot">
        <b-col sm="12" v-if="timeSlots.length > 0">
          <b-alert v-if="isAllDay" variant="success" class="mt-3" show
            >{{ $t('quoteOfferForm.serviceOpenAllDay') }}
          </b-alert>
          <b-alert
            v-else
            variant="success"
            class="mt-3"
            show
            v-html="
              $t('quoteOfferForm.openingHour', {
                slots: slots,
              })
            "
          >
          </b-alert>
        </b-col>
        <b-col v-else>
          <b-alert
            variant="warning"
            class="mt-3"
            show
            v-html="
              $t('quoteOfferForm.serviceNotAvailable', {
                day: day,
              })
            "
          >
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.dateLabel') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="3">
          <form-group name="checkOut" attribute="form.checkInCheckOut">
            <div class="datepicker-trigger">
              <input
                type="text"
                id="datepicker-trigger"
                :placeholder="$t('quoteOfferForm.date')"
                :value="formatDates(dateOne)"
                class="form-control"
                readonly
                @click="showCalendar = !showCalendar"
              />              
              <date-picker-page
                :show="showCalendar && !loadingComponent"
                :availableDates="availableDates"
                :mindate="this.minDateValue"
                :enddate="this.maxDateValue"
                :focusDate="dateOne"
                @dateSelected="
                  (val) => {
                    dateOne = val;
                    setDateOne(val);
                  }
                "
                @closeCalendar="showCalendar = false"
                ref="dataPicker"
              />
            </div>
          </form-group>
        </b-col>
        <b-col sm="4">
          <b-spinner
            type="grow"
            label="Spinning"
            v-if="loading || loadingComponent"
          ></b-spinner>
          <div v-else-if="dateOne">
            <form-group
              v-if="availabilityOptions.length"
              name="selectedSlot"
              attribute="arrivalTime"
            >
              <template slot-scope="{ attrs }">
                <b-form-select
                  v-bind="attrs"
                  v-model="selectedSlot"
                  :options="availabilityOptions"
                  :label="$t('arrivalTime')"
                  :disabled="loading || disabled"
                  @change="onSelectedSlot"
                ></b-form-select>                
                <!-- <b-form-input
                v-else
                id="input-none"
                value="Tutto il giorno"
                :readonly="true"
              ></b-form-input> -->
              </template>
            </form-group>
            <div v-else>
              <b-form-row>
                <b-col>
                  <form-group name="arrivalHour" attribute="arrivalTime">
                    <template slot-scope="{ attrs }">
                      <b-form-select
                        v-model="selectedHours"
                        v-bind="attrs"
                        :options="hours"
                        :label="$t('hourLabel')"
                        :placeholder="$t('hourPlaceholder')"
                        :disabled="loading || disabled"
                        @change="changeHour"
                      ></b-form-select>
                    </template>
                  </form-group>                  
                </b-col>
                <b-col>
                  <form-group name="arrivalMinute" attribute="minuteLabel">
                    <template slot-scope="{ attrs }">
                      <b-form-select
                        v-model="selectedMinutes"
                        v-bind="attrs"
                        :options="minutes"
                        :label="$t('minuteLabel')"
                        :placeholder="$t('minutePlaceholder')"
                        :disabled="loading || disabled"
                        @change="composeDate"
                      ></b-form-select>
                    </template> </form-group
                ></b-col>
              </b-form-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="model.rates.length > 0">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.rateLabel') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="3">
          <form-group name="rateID" attribute="form.rateID">
            <template slot-scope="{ attrs }">
              <b-form-select
                v-bind="attrs"
                v-model="model.rateID"
                :options="model.rates"
              ></b-form-select></template
          ></form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <request-room-component
            :index="0"
            :roomNumber="1"
            :room="model.rooms[0]"
            :v="$v.model.rooms.$each[0]"
            :maxValueAdults="maxValueAdults"
            :show-label="false"
            :disabled="loading || disabled"
          />
        </b-col>
      </b-row>
      <b-row v-show="showCustomError">
        <b-col>
          <b-alert variant="danger" show>{{
            $t('validation.minRangeAvailable', {
              text: minRangeAvailableText,
            })
          }}</b-alert>
        </b-col>
      </b-row>
      <b-row v-show="showCapacityError">
        <b-col>
          <b-alert variant="danger" show>{{
            $t('validation.residualCapacityAvailable', {
              text: residualCapacity,
            })
          }}</b-alert>
        </b-col>
      </b-row>
      <div style="margin-bottom: 20px">
        <form-summary :attributes="attributes" />
      </div>
    </form-wrapper>
    <b-row class="my-3" v-else>
      <b-col sm="12">
        <b-alert variant="danger" show>{{ $t('offerNotTransactive') }}</b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  minValue,
  maxValue,
  numeric,
  between,

  // helper
} from 'vuelidate/lib/validators';

import RequestRoomComponent from '@/components/shared/RequestRoomComponent';
import DatePickerPage from '@/components/shared/DatePickerPage';

import { OfferRequestService } from '@/common/ApiService';

import {
  format,
  parse,
  startOfDay,
  endOfDay,
  differenceInSeconds,  
  getHours,
  getMinutes,
  addMinutes,
  addHours,
  isEqual,
  isAfter,
  isBefore,
  isValid,
  isToday
} from 'date-fns';
// import isAfter from 'date-fns/is_after';

export default {
  name: 'RequestQuoteStepOne',
  props: {
    formConfiguration: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Number,
      required: false,
    },
    model: {
      type: Object,
      required: true,
    },
    maxValueAdults:{
      type: Number,
      default: 10,
    },
  },
  components: { RequestRoomComponent, DatePickerPage },
  mixins: [validationMixin],
  extends: singleErrorExtractorMixin,
  data() {
    return {
      showCalendar: false,
      availableDates: [],      
      date: null,
      hours: [],
      minutes: [],
      selectedSlot: null,
      capacity: null,
      reservedCapacity: null,
      occupiedCapacity: null,
      selectedMinutes: null,
      selectedHours: null,
      allDay: false,
      offerID: this.value,
      loadingComponent: false,
      showError: false,
      showCustomError: false,
      showCapacityError: false,
      minRangeAvailableText: '',
      residualCapacity: null,
      slots: null,
      timeSlots: [],
      isTransactive: true,
      isTimeSlot: true,
      duration: null,
      showDisabledTime: false,
      showDisabled: false,
      rates: [],
      // default slot
      deltaMinutes: 15,
      mainProps: {
        // blank: true,
        blankColor: '#777',
        width: 30,
        height: 30,
        class: 'm1',
      },
      roomsNumber: 1,
      minValueAdults: 1,
      // maxValueAdults: 30,
      minValueRoomsNumber: 1,
      maxValueRoomsNumber: 6,
      minValueChildren: 0,
      maxValueChildren: 30,
      // vue-airbnb-style-datepicker
      dateFormat: 'DD/MM/YYYY',
      dateOne: '',

      minDateValue: new Date().toISOString(),
      maxDateValue: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 2,
        new Date().getDate()
      ).toISOString(),

      /* TEST THIS VARIABLES BEFORE REMOVE*/
      /* minDateValue: new Date().toISOString().slice(0, 10),
      maxDateValue: new Date(
        new Date().getFullYear() + 1,
        new Date().getMonth() + 1,
        new Date().getDate()
      )
        .toISOString()
        .slice(0, 10), */

      attributes: {
        'rooms.adult': this.$t('form.adult'),
        'rooms.childrenAges': this.$t('form.childrenAgeLabel'),
        'rooms.children': this.$t('form.children'),
        date: this.$t('quoteOfferForm.date'),
      },
    };
  },
  validations: {
    model: {
      startDate: { required },
      rateID: {
        required: requiredIf(function () {
          return this.model.rates.length > 1;
        }),
      },
      rooms: {
        minLength: minLength(1),
        $each: {
          adult: {
            required,
            minValue: minValue(1),
            // (value, item) => {
            //   return !(value == 0 && item.children == 0);
            // },
            maxValue: maxValue(30),
          },
          children: {
            required,
            minValue: (value, item) => {
              return !(value === 0 && item.adult === 0);
            },
            maxValue: maxValue(30),
          },
          childrenAges: {
            maxLengthArray: maxLength(30),
            $each: {
              numeric,
              required: (value, item) => {
                return !(value === null);
              },
              between: between(0, 17),
            },
          },
        },
      },
    },
  },
  mounted() {
    // this.minDate
    if (this.hours.length == 0) {
      this.populateHours();
    }
    if (this.minutes.length == 0) {
      this.populateMinutes();
    }
    this.loadAvailability();
    this.populateDate();
    this.setLanguageAttributes();
    document.addEventListener('click', this.handleClickOutside, true);    
  },
  computed: {
    availabilityOptions() {      
      if (this.timeSlots && this.timeSlots.length && this.isTimeSlot) {        
        return this.timeSlots.map((item) => {
          return {
            value: item.startDate,
            text: `${format(item.startDate, 'HH:mm')} ${
              !item.isReservable ? ` - ${this.$t('notAvailable')}` : ''
            }`,
            disabled: !item.isReservable,
          };
        });        
      }
      return [];
    },
    start() {
      return format(this.checkIn, 'HH:mm');
    },
    end() {
      return format(this.checkOut, 'HH:mm');
    },
    day() {
      return format(this.dateOne, 'DD-MM-YYYY');
    },
    isAllDay() {
      return (
        this.checkOut &&
        this.checkIn &&
        differenceInSeconds(this.checkOut, this.checkIn) === 86400
      );
    },
    disabled() {      
      let disabled = this.timeSlots.length == 0;
      //  ||
      // (this.timeSlots.length === 1 && !this.timeSlots[0].isReservable);
      this.$emit('disableNextButtonForTimeSlots', disabled);
      return disabled;
    },
  },
  methods: {    
    async loadAvailability() {      
      this.loadingComponent = true;       
      let channelID = this.$route.query.channelID;      
      const requestData = {
        startDate: this.minDateValue,
        endDate: this.maxDateValue,
        resources: [
          {
            serviceID: 0,
            orderID: [0],
            offerID: this.offerID,
            minOccupiedCapacityAge: 0
          }
        ],
        channelID: channelID
      };
      
      try {        
        const response = await OfferRequestService.getAvailabilityOnPeriod(requestData);         
        this.availableDates = response.data;
      } catch (error) {
        console.error("Errore nel caricamento delle disponibilità:", error);
      } finally {
        this.loadingComponent = false;
      }
    },

    handleClickOutside(event) {
      
      if (this.$refs.dataPicker && !this.$refs.dataPicker.$el.contains(event.target)) {        
        this.showCalendar = false;
      }
      
    },
    
    populateDate() {
      this.dateOne = this.$route.query.date 
      /*let today = format(new Date(), 'YYYY-MM-DD');
      let checkIn = null;      
      
      if (!isToday(this.$route.query.date)) {
        checkIn = this.$route.query.date;  
      } 
      
      if (this.formConfiguration.startDate) {        
        this.minDateValue = this.formConfiguration.startDate;
        checkIn = format(this.formConfiguration.startDate, 'YYYY-MM-DD');        
      }

      if (isAfter(checkIn, today)) today = checkIn;      
      this.dateOne = today; */
    },
    validateCapacitySlot() {
      let counter = 0;
      if (this.model.hasBufferLimit) {
        this.model.rooms.forEach((room) => {
          counter += room.adult;
          if (!this.model.hasAgeCapacity) {
            counter += room.children;
          } else
            room.childrenAges.forEach((age) => {
              counter += age > this.model.ageCapacity ? 1 : 0;
            });
        });
      }
      this.residualCapacity =
        this.capacity == -1
          ? 1000
          : this.capacity -
            this.reservedCapacity -
            this.occupiedCapacity -
            this.model.bufferLimit;
      let capacityError = this.residualCapacity < counter;

      return capacityError;
    },
    validateSlot() {      
      let date = addHours(new Date(), this.model.beforeStartBookingOptionHours);      
      date = addMinutes(date, this.model.beforeStartBookingOptionMinutes);      

      if (this.model.beforeStartBookingOptionHours > 0) {
        this.minRangeAvailableText =
          this.model.beforeStartBookingOptionHours > 1
            ? `${this.model.beforeStartBookingOptionHours} ore`
            : `${this.model.beforeStartBookingOptionHours} ora`;
      }
      if (this.model.beforeStartBookingOptionMinutes > 0) {
        this.minRangeAvailableText +=
          this.minRangeAvailableText != '' ? ' e ' : '';
        this.minRangeAvailableText +=
          this.model.beforeStartBookingOptionMinutes > 1
            ? `${this.model.beforeStartBookingOptionMinutes} minuti`
            : `${this.model.beforeStartBookingOptionMinutes} minuto`;
      }
      
      let slotError =
        isEqual(date, this.model.startDate) ||
        isAfter(date, this.model.startDate);      
      return slotError;
    },
    async setDateOne(value) {      
      this.selectedHours = null;
      this.selectedMinutes = null;
      this.formatDates(value);
      await this.loadOfferAvailability();      
      /* this.model.startDate = parse(value);       */
      if (this.timeSlots) {
        const defaultMin = getMinutes(this.timeSlots[0].startDate)        
        this.model.startDate = addMinutes(
          addHours(value, this.selectedHours),
          defaultMin
        );
      }
            
    },
    async loadOfferAvailability() {      
      this.loadingComponent = true;
      this.timeSlots = [];
      this.isTimeSlot = true;
      this.checkIn = null;
      this.checkOut = null;
      this.duration = null;
      this.selectedSlot = null;
      this.capacity = null;
      this.reservedCapacity = null;
      this.occupiedCapacity = null;
      this.model.startDate = null;
      this.showCustomError = false;
      this.residualCapacity = null;
      this.$v.$reset();
      try {
        let channelID = 0;        
        if (this.$route.query.channelID) {
          channelID = parseInt(this.$route.query.channelID);
        }
        const response = await OfferRequestService.getAvailabilitySlots(
          this.offerID,
          {
            start: startOfDay(this.date),
            end: endOfDay(this.date),
            channelID,
          }
        );
        this.timeSlots = [];
        this.model.beforeStartBookingOptionHours =
          response.data.beforeStartBookingOptionHours;
        this.beforeStartBookingOptionHours =
          this.model.beforeStartBookingOptionHours;
        this.model.beforeStartBookingOptionMinutes =
          response.data.beforeStartBookingOptionMinutes;
        this.model.hasBufferLimit = response.data.hasBufferLimit;
        this.model.bufferLimit = response.data.bufferLimit;
        this.model.hasAgeCapacity =
          response.data.hasAgeCapacity !== null &&
          response.data.hasAgeCapacity !== undefined
            ? response.data.hasAgeCapacity
            : false;
        this.model.ageCapacity = response.data.ageCapacity;
        response.data.timeSlots.forEach((timeSlot) => {          
          if (
            this.showDisabled ||
            isAfter(parse(timeSlot.startDate), new Date())
          ) {
            this.timeSlots.push(timeSlot);
          }
        });

        this.isTimeSlot = response.data.isTimeSlot;
        this.isTransactive = response.data.isTransactive;
        this.duration = response.data.minDuration;
        
        if (!this.isTimeSlot && this.timeSlots.length > 0) {          
          let defaultSlot = this.timeSlots[0];
          let lastSlot = this.timeSlots[this.timeSlots.length - 1];
          this.checkIn = parse(defaultSlot.startDate);
          this.checkOut = parse(lastSlot.endDate);
          this.slots = '';
          for (
            let index = 0;
            index < this.timeSlots.length && index < 3;
            index++
          ) {
            const element = this.timeSlots[index];
            if (this.slots.length > 0) {
              this.slots += ' / ';
            }
            this.slots += this.$t('quoteOfferForm.eachOpeningHour', {
              start: format(element.startDate, 'HH:mm'),
              end: format(element.endDate, 'HH:mm'),
            });
          }                    
          this.model.startDate = parse(defaultSlot.startDate); // ?????          
          this.hours = [];
          this.minutes = [];
          this.timeSlots.forEach((element) => {
            let minDate = getHours(element.startDate);
            let maxDate = getHours(element.endDate);
            let minValue = element.startDate;
            if (isAfter(element.endDate, minDate)) {
              for (; isAfter(element.endDate, minValue); ) {
                const option = { text: getHours(minValue).toString() };
                this.hours.push(option);
                minValue = addHours(minValue, 1);
              }
              // }
              // if (minDate !== maxDate) {
              //   for (var i = 0; i < maxDate - minDate; i++) {
              //     const option = { text: (minDate + i).toString() };
              //     this.hours.push(option);
              //   }
            } else {
              this.populateHours();
            }
          });
        } else if (
          this.timeSlots.length === 1 &&
          this.timeSlots[0].isReservable
        ) {
          // if (!this.isTimeSlot) {
          //   let defaultSlot = this.timeSlots[0];
          //   this.checkIn = parse(defaultSlot.startDate);
          //   this.checkOut = parse(defaultSlot.endDate);
          //   this.model.startDate = parse(defaultSlot.startDate);
          //   this.loadAvailableDate();
          // } else {
          const difference = differenceInSeconds(
            this.timeSlots[0].endDate,
            this.timeSlots[0].startDate
          );
          // a day
          if (difference === 86400) {
            this.allDay = true;
          } else {
            this.allDay = false;
          }          
          this.model.startDate = parse(this.timeSlots[0].startDate);         

          this.selectedSlot = this.timeSlots[0].startDate;
          this.capacity = this.timeSlots[0].capacity;
          this.reservedCapacity = this.timeSlots[0].reservedCapacity;
          this.occupiedCapacity = this.timeSlots[0].occupiedCapacity;
          this.loadAvailableDate();
          // }
        } else if (this.timeSlots.length > 1) {
          let startDate = null;
          let endDate = null;
          this.timeSlots.forEach((timeslot) => {
            if (
              startDate === null ||
              (isValid(startDate) &&
                isAfter(startDate, parse(timeslot.startDate)))
            ) {
              startDate = parse(timeslot.startDate);
            }
            if (
              endDate === null ||
              (isValid(endDate) && isBefore(endDate, parse(timeslot.endDate)))
            ) {
              endDate = parse(timeslot.endDate);
            }
          });
          this.checkIn = startDate;
          this.checkOut = endDate;          
          this.selectedSlot = this.timeSlots[0].startDate;
          this.capacity = this.timeSlots[0].capacity;          
          this.reservedCapacity = this.timeSlots[0].reservedCapacity;
          this.occupiedCapacity = this.timeSlots[0].occupiedCapacity;
          this.loadAvailableDate();
        }
      } catch (e) {
        this.showError = true;
        this.$emit('error', e); // TODO: handle antoher error type
      } finally {
        this.loadingComponent = false;
      }
      // this.loading = false;
    },
    formatDates(dateOne) {
      let formattedDates = '';
      if (dateOne) {
        this.date = parse(dateOne, 'YYYY-MM-DD');
        formattedDates = format(dateOne, this.dateFormat);
      }
      return formattedDates;
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$v.$touch();        
        this.showCustomError = this.validateSlot();
        if (this.showCustomError) {
          reject({ invalid: true });
          return;
        }
        this.showCapacityError = this.validateCapacitySlot();
        if (this.showCapacityError) {
          reject({ invalid: true });
          return;
        }
        if (!this.$v.$invalid) {
          resolve(true);
        } else {
          reject({ invalid: true });
        }
      });
    },
    setLanguageAttributes() {
      this.attributes = {
        property: this.$t('form.property'),
        roomType: this.$t('form.roomType'),
        accomodation: this.$t('form.accomodation'),
        'rooms.adult': this.$t('form.adult'),
        'rooms.childrenAges': this.$t('form.childrenAgeLabel'),
        'rooms.children': this.$t('form.children'),
        checkIn: this.$t('form.checkInCheckOut'),
        checkOut: this.$t('form.checkOut'),
        rateID: this.$t('form.rateID'),
      };      
    },
    
    onSelectedSlot(value) {      
      this.model.startDate = parse(value);
      this.$v.$touch();      
    },
    composeDate() {      
      if (this.selectedHours && this.selectedMinutes) {        
        this.model.startDate = addMinutes(
          addHours(this.date, this.selectedHours),
          this.selectedMinutes
        );
      }      
    },
    loadAvailableDate() {
      let startHour = getHours(this.checkIn);
      let endHour = getHours(addMinutes(this.checkOut, -this.duration || 0));

      let duration = Math.floor(this.duration / 60);
      if (endHour - startHour - duration <= 0) {
        endHour = startHour;
      }
      this.showCustomError = false;
      this.showCapacityError = false;
      this.populateHours(startHour, endHour);
    },
    populateHours(start = 0, end = 23) {
      this.hours = [];
      for (let i = 0; i < 24; i++) {
        //   10  >= 3  &&  3 <= 17        
        let enabledHour = start <= i && i <= end;        
        if (this.showDisabledTime || enabledHour) {
          const option = { text: i.toString(), disabled: !enabledHour };
          this.hours.push(option);
        }
      }            
      if (this.hours.length >= 1) {
        if (this.selectedSlot) {          
          this.selectedHours = getHours(this.selectedSlot);
        } else {
          this.selectedHours = this.hours[0].text;        
        }
        this.changeHour();
      }
    },
    populateMinutes(start = 0, end = 3) {
      this.minutes = [];
      for (let i = 0; i < 4; i++) {
        let enabledMinutes = start <= i && i <= end;
        if (this.showDisabledTime || enabledMinutes) {
          const option = {
            text: (i * this.deltaMinutes).toString(),
            disabled: !enabledMinutes,
          };
          this.minutes.push(option);
        }
      }
      if (this.minutes.length >= 1) {          
        this.selectedMinutes = this.minutes[0].text;
        //this.composeDate();
      }
    },
    getMinimumMinutes() {
      // start date = 9.15
      // hour = 10
      let selectedDate = startOfDay(this.checkIn);
      selectedDate = addHours(selectedDate, this.selectedHours);
      for (let i = 0; i * this.deltaMinutes < 60; i++) {
        if (
          isAfter(selectedDate, this.checkIn) ||
          isEqual(selectedDate, this.checkIn)
        ) {
          return i;
        }
        selectedDate = addMinutes(selectedDate, this.deltaMinutes);
      }
    },
    getMaximumMinutes() {
      // start date = 9.15
      // hour = 10
      let selectedDate = startOfDay(this.checkOut);
      selectedDate = addHours(selectedDate, this.selectedHours);
      for (let i = 3; i >= 0; i--) {
        let selected = addMinutes(
          addMinutes(selectedDate, this.deltaMinutes * i),
          this.duration
        );
        if (
          isAfter(this.checkOut, selected) ||
          isEqual(this.checkOut, selected)
        ) {
          return i;
        }
      }
    },
    changeHour() {
      let minimumMinutes = this.getMinimumMinutes();
      let maximumMinutes = this.getMaximumMinutes();
      this.populateMinutes(minimumMinutes, maximumMinutes);
    },
  },
  watch: {
    async offerID(val) {      
      if (val) {
        await this.loadOfferAvailability();
      }
    },
    'formConfiguration.startDate'(val) {
      if (val) {
        this.populateDate();
      }
    },
  },
};
</script>
<style scoped>
.datepicker-trigger input[type='text'] {
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  background-color: white;
}
.numericSelector {
  max-width: 60px;
  text-align: center;
  background-color: white;
}
.childrenAgeSelector {
  max-width: 125px;
}

.dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.dropdown li:last-child {
  border-bottom: none;
}

.dropdown li a {
  padding: 10px 20px;
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1.25em;
}

.dropdown li a .fa {
  padding-right: 0.5em;
}
</style>
<style>
select > option:disabled {
  background-color: lightgrey;
  color: black;
}
</style>
